import script from "./FamilyEduHome.vue?vue&type=script&setup=true&lang=js"
export * from "./FamilyEduHome.vue?vue&type=script&setup=true&lang=js"

import "./FamilyEduHome.vue?vue&type=style&index=0&id=12bb6918&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12bb6918"]])

export default __exports__